import { Injectable } from "@angular/core";
import equal from "fast-deep-equal";
import { BehaviorSubject, Observable, distinctUntilChanged } from "rxjs";
import { ICustomFieldsState, ICustomFieldsStoreState } from "@gtmhub/customFields/redux/custom-field-reducer";
import { reduxStoreContainer } from "@gtmhub/state-management/state-management.module";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { ICustomField } from "@webapp/custom-fields/models/custom-fields.models";
import { EditableCustomFieldsState } from "./editable-custom-fields-state";

@Injectable({
  providedIn: "root",
})
export class EditableCustomFieldFacade extends BaseFacade<ICustomField, ICustomField, EditableCustomFieldsState, null> {
  private editableCustomFieldsSubject: BehaviorSubject<ICustomFieldsState> = new BehaviorSubject(
    reduxStoreContainer.reduxStore.getState<ICustomFieldsStoreState>().customFields
  );

  constructor(state: EditableCustomFieldsState) {
    super(state, null);

    const { reduxStore } = reduxStoreContainer;
    reduxStore.subscribe(() => {
      const state: ICustomFieldsState = reduxStoreContainer.reduxStore.getState<ICustomFieldsStoreState>().customFields;
      this.editableCustomFieldsSubject.next(state);
    });
  }

  public getCustomFields$(targetType: string): Observable<ICustomFieldsState> {
    return this.editableCustomFieldsSubject.pipe(
      distinctUntilChanged((prev, curr) => {
        const oldValues = prev.map[targetType] ? prev.map[targetType] : [];
        const newValues = curr.map[targetType] ? prev.map[targetType] : [];

        return oldValues.length === newValues.length && equal([...oldValues], [...newValues]);
      })
    );
  }
}
